import { useCallback, useState } from 'react';

export function useBottomSuccessToast() {
  const [state, setState] = useState({ key: 0, open: false, message: '' });

  const show = useCallback((message: string) => {
    setState(s => ({ key: s.key + 1, open: true, message }));
  }, []);

  const onClose = useCallback(() => {
    setState(s => ({ ...s, open: false }));
  }, []);

  return { show, onClose, snackbarKey: state.key, open: state.open, message: state.message };
}
